import { NavLink } from "react-router-dom";
export default function NavigationLink({ icon, title, address}){
    return (
        <div className="tabCell">
            <NavLink
              to={address}
              className="navLink"
            >
              {icon}
              {title}
            </NavLink>
          </div>
    )
}